export const dummyProducts = [
  {
    id: '4',
    number: '4',
    product_name: 'Kemeja Denim Biru',
    img_url: '/assets/temporary-product.png',
    qty_sold: 20,
    sale_perday: 3,
    price: 300000,
    category_id: 2,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '5',
    number: '5',
    product_name: 'Celana Panjang Jeans Slim Fit',
    img_url: '/assets/temporary-product.png',
    qty_sold: 35,
    sale_perday: 7,
    price: 400000,
    category_id: 2,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '6',
    number: '6',
    product_name: 'Hoodie Oversized Abu-abu',
    img_url: '/assets/temporary-product.png',
    qty_sold: 25,
    sale_perday: 5,
    price: 280000,
    category_id: 2,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '7',
    number: '7',
    product_name: 'Sepatu Sneakers Hitam',
    img_url: '/assets/temporary-product.png',
    qty_sold: 15,
    sale_perday: 2,
    price: 600000,
    category_id: 4,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '8',
    number: '8',
    product_name: 'Topi Baseball Trucker',
    img_url: '/assets/temporary-product.png',
    qty_sold: 45,
    sale_perday: 9,
    price: 100000,
    category_id: 5,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '9',
    number: '9',
    product_name: 'Kaos Polos Putih',
    img_url: '/assets/temporary-product.png',
    qty_sold: 55,
    sale_perday: 11,
    price: 75000,
    category_id: 1,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '10',
    number: '10',
    product_name: 'Jaket Kulit Asli Coklat',
    img_url: '/assets/temporary-product.png',
    qty_sold: 10,
    sale_perday: 2,
    price: 1200000,
    category_id: 2,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '11',
    number: '11',
    product_name: 'Tas Ransel Canvas Motif',
    img_url: '/assets/temporary-product.png',
    qty_sold: 18,
    sale_perday: 3,
    price: 500000,
    category_id: 6,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '12',
    number: '12',
    product_name: 'Cincin Titanium Hitam',
    img_url: '/assets/temporary-product.png',
    qty_sold: 8,
    sale_perday: 1,
    price: 350000,
    category_id: 7,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '13',
    number: '13',
    product_name: 'Dompet Kulit Asli Coklat',
    img_url: '/assets/temporary-product.png',
    qty_sold: 22,
    sale_perday: 4,
    price: 200000,
    category_id: 8,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '14',
    number: '14',
    product_name: 'Jam Tangan Pria Stainless Steel',
    img_url: '/assets/temporary-product.png',
    qty_sold: 30,
    sale_perday: 6,
    price: 450000,
    category_id: 9,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '15',
    number: '15',
    product_name: 'Kacamata Hitam Retro',
    img_url: '/assets/temporary-product.png',
    qty_sold: 12,
    sale_perday: 2,
    price: 150000,
    category_id: 10,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '16',
    number: '16',
    product_name: 'Scarf Rajut Warna-warni',
    img_url: '/assets/temporary-product.png',
    qty_sold: 28,
    sale_perday: 4,
    price: 80000,
    category_id: 11,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '17',
    number: '17',
    product_name: 'Gelang Perak Unisex',
    img_url: '/assets/temporary-product.png',
    qty_sold: 19,
    sale_perday: 3,
    price: 180000,
    category_id: 12,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '18',
    number: '18',
    product_name: 'Sandal Jepit Anak Lucu',
    img_url: '/assets/temporary-product.png',
    qty_sold: 24,
    sale_perday: 5,
    price: 50000,
    category_id: 13,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '19',
    number: '19',
    product_name: 'Dress Mini Floral',
    img_url: '/assets/temporary-product.png',
    qty_sold: 14,
    sale_perday: 2,
    price: 350000,
    category_id: 19,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '20',
    number: '20',
    product_name: 'Earphone Wireless Sport',
    img_url: '/assets/temporary-product.png',
    qty_sold: 32,
    sale_perday: 6,
    price: 120000,
    category_id: 19,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '21',
    number: '21',
    product_name: 'Jaket Parka Anti Air',
    img_url: '/assets/temporary-product.png',
    qty_sold: 17,
    sale_perday: 3,
    price: 550000,
    category_id: 18,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
  {
    id: '22',
    number: '22',
    product_name: 'Tas Tangan Wanita Vintage',
    img_url: '/assets/temporary-product.png',
    qty_sold: 26,
    sale_perday: 4,
    price: 380000,
    category_id: 18,
    stock: 10,
    product_code: 'KEM-DNM-BRU',
  },
];

export const dummyProductSearch = [
  {
    id: '01963010-f57e-7c02-a396-d74fde8a9f74',
    product_name: 'Buku Gambar',
    description: '<p class="text-node">Buat tes</p>',
    sell_price: 20000,
    discount_price: 16000,
    price_range: [],
    product_assets: [
      {
        assets_type: 'image',
        assets_url: 'https://picsum.photos/seed/notebook/600/400',
      },
    ],
    product_weight: 250,
    product_height: 10,
    product_width: 10,
    product_length: 10,
    has_variation: false,
    sku: 'BK-GMBR-01',
    available_qty: 800,
    slug: 'buku-gambar',
    category_name: 'alat-tulis',
    qty_sold: 337,
    pricebook: [],
    best_seller: true,
    new_arrival: false,
  },
  {
    id: '01963010-f57e-7c02-a396-d74fde8a9f75',
    product_name: 'Pensil 2B',
    description: '<p class="text-node">Cocok untuk ujian</p>',
    sell_price: 5000,
    discount_price: 4000,
    price_range: [],
    product_assets: [
      {
        assets_type: 'image',
        assets_url: 'https://picsum.photos/seed/pencil/600/400',
      },
    ],
    product_weight: 50,
    product_height: 5,
    product_width: 2,
    product_length: 2,
    has_variation: false,
    sku: 'PNSL-2B-01',
    available_qty: 1500,
    slug: 'pensil-2b',
    category_name: 'alat-tulis',
    qty_sold: 540,
    pricebook: [],
    best_seller: true,
    new_arrival: false,
  },
  {
    id: '01963010-f57e-7c02-a396-d74fde8a9f76',
    product_name: 'Penghapus Putih',
    description: '<p class="text-node">Bersih tanpa noda</p>',
    sell_price: 3000,
    discount_price: 2500,
    price_range: [],
    product_assets: [
      {
        assets_type: 'image',
        assets_url: 'https://picsum.photos/seed/eraser/600/400',
      },
    ],
    product_weight: 20,
    product_height: 2,
    product_width: 3,
    product_length: 1,
    has_variation: false,
    sku: 'ERSP-01',
    available_qty: 2000,
    slug: 'penghapus-putih',
    category_name: 'alat-tulis',
    qty_sold: 670,
    pricebook: [],
    best_seller: true,
    new_arrival: false,
  },
  {
    id: '01963010-f57e-7c02-a396-d74fde8a9f77',
    product_name: 'Rautan Pensil',
    description: '<p class="text-node">Rautan mini portable</p>',
    sell_price: 7000,
    discount_price: 6000,
    price_range: [],
    product_assets: [
      {
        assets_type: 'image',
        assets_url: 'https://picsum.photos/seed/ruler/600/400',
      },
    ],
    product_weight: 30,
    product_height: 3,
    product_width: 3,
    product_length: 3,
    has_variation: false,
    sku: 'RUTN-01',
    available_qty: 1200,
    slug: 'rautan-pensil',
    category_name: 'alat-tulis',
    qty_sold: 420,
    pricebook: [],
    best_seller: false,
    new_arrival: true,
  },
  {
    id: '01963010-f57e-7c02-a396-d74fde8a9f78',
    product_name: 'Spidol Warna',
    description: '<p class="text-node">Set isi 12 warna</p>',
    sell_price: 30000,
    discount_price: 25000,
    price_range: [],
    product_assets: [
      {
        assets_type: 'image',
        assets_url: 'https://picsum.photos/seed/stick/600/400',
      },
    ],
    product_weight: 400,
    product_height: 15,
    product_width: 10,
    product_length: 5,
    has_variation: false,
    sku: 'SPDL-WRN-01',
    available_qty: 900,
    slug: 'spidol-warna',
    category_name: 'alat-tulis',
    qty_sold: 289,
    pricebook: [],
    best_seller: false,
    new_arrival: true,
  },
];
